import { LightningElement, api } from "lwc";
import type { ModalSummary, values } from "./types";
export type { ModalSummary };

const UPDATE = 'Update';
const WELCOME = 'Welcome';

export default class LocaleWelcomeModal extends LightningElement {

    @api summary: ModalSummary = null!;
    @api currencylistoptions : values[] = null!;
    @api currencyvalue : string = null!;
    isModalOpen: boolean = true;
    currentCountry: string = null!;
    currentLanguage: string = null!;
    saveDisabled: boolean = false;
    currentValues = {
        country: true,
        currency: true,
        language: true
    }
    ALLOWED_TAGS = ["a"]

    private get hasModalSummary() {
        return this.summary !== null;
    }

    private get heading() {
        return this.summary?.heading;
    }

    private get subtitle() {
        return this.summary?.subtitle.replaceAll('&lt;', '<').replaceAll('&gt;', '>');
    }

    private get modalTypeUpdate() {
        return this.summary?.type === UPDATE ? true : false;
    }

    private get modalTypeWelcome() {
        return this.summary?.type === WELCOME ? true : false;
    }

    private get billingCountryLabel() {
        return this.summary?.countryList.label;
    }

    private get currencyLabel() {
        return this.summary?.currencyListLabel;
    }

    private get languageLabel() {
        return this.summary?.languageList.label;
    }

    private get optionsCountry() {
        return this.summary?.countryList.options;
    }

    private get optionsCurrency() {
        return this.currencylistoptions;
    }

    private get optionsLanguage() {
        return this.summary?.languageList.options;
    }

    private get countryValue() {
        this.currentValues.country = !!this.currentCountry;
        this.saveDisabled = Object.values(this.currentValues).includes(false);
        return this.currentCountry;
    }
    private get currencyValue() {
        this.currentValues.currency = !!this.currencyvalue;
        this.saveDisabled = Object.values(this.currentValues).includes(false);
        return this.currencyvalue;
    }
    private get languageValue() {
        this.currentValues.language = !!this.currentLanguage;
        this.saveDisabled = Object.values(this.currentValues).includes(false);
        return this.currentLanguage;
    }

    private get cancelButtonLabel() {
        return this.summary?.cancelButtonLabel;
    }

    private get saveButtonLabel() {
        return this.summary?.saveButtonLabel;
    }

    private get disclaimerLabel() {
        return this.summary?.disclaimerLabel;
    }

    handleSave() {
        if (!this.saveDisabled) {
            let detailsObj = [
                { value: this.currentCountry },
                { value: this.currencyvalue },
                { value: this.currentLanguage }
            ];
            this.dispatchEventMethod("handlewelcomemodaldata", detailsObj);
            this.isModalOpen = false;
        }
    }

    handleChangeCountry(event: MouseEvent) {
        let value = event.detail.toString();
        this.currentCountry = value;
        let detailsObj = [{ value: value }];
        this.dispatchEventMethod("changecountry", detailsObj);
    }
    handleChangeCurrency(event: MouseEvent) {
        let value = event.detail.toString();
        this.currencyvalue = value;
        let detailsObj = [{ value: value }];
        this.dispatchEventMethod("changecurrency", detailsObj);
    }
    handleChangeLanguage(event: MouseEvent) {
        let value = event.detail.toString();
        this.currentLanguage = value;
        let detailsObj = [{ value: value }];
        this.dispatchEventMethod("changelanguage", detailsObj);
    }
    handleClose() {
        this.isModalOpen = false;
        this.dispatchEventMethod("closemodal");
    }

    handleTabKeyDown(event: KeyboardEventInit){
        if (event.key === 'Enter') {
            this.handleClose();
        }
    }

    dispatchEventMethod(eventName: string, detailsObj?: { value: string }[]) {
        this.dispatchEvent(
            new CustomEvent(eventName, {
                detail: detailsObj,
            })
        );
    }

    handleOutsideClick(event: MouseEvent) {
        const container = this.template.querySelector(".modal-container");
        if ((event.target as HTMLElement)?.contains(container)) {
            this.isModalOpen = false;
            this.dispatchEventMethod("closemodal");
        }
    }

    connectedCallback() {
        window.addEventListener("keydown", this.handleKeyDown);
        this.currentCountry = this.summary?.countryList.value;
        this.currentLanguage = this.summary?.languageList.value;
    }

    disconnectedCallback() {
        window.removeEventListener("keydown", this.handleKeyDown);
    }

    private handleKeyDown = (e: KeyboardEventInit) => {
        if (e.key === "Esc" || e.key === "Escape") {
            this.handleClose();
        }
    };
}